import {Box} from 'platform/foundation';

import i18n from '@dms/i18n';
import {useFormRenderer} from '@dms/teas';

export const AuditSettingsValidateField = () => {
  const {Field} = useFormRenderer();

  return (
    <Box paddingBottom={2}>
      <Field
        as="checkbox"
        label={i18n.t`page.vehicleSettings.labels.validateMandatoryItems`}
        name="validation"
      />
    </Box>
  );
};
